import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isTesterKycApproved, testerKycBlockedMessage } from '../../utils/testerKyc';

export default function TesterKycBanner({ sx }) {
  const { user } = useSelector((state) => state.auth);
  // Soft onboarding uses TesterProfileIncompleteBanner until the profile form is done.
  if (!user || user.role !== 'tester' || !user.profileCompleted || isTesterKycApproved(user)) return null;

  const isRejected = user.kycStatus === 'rejected';

  return (
    <Box
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: '8px',
        bgcolor: isRejected ? '#fef2f2' : '#faf0f1',
        border: `1px solid ${isRejected ? '#fecaca' : '#bfdbfe'}`,
        ...sx,
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: isRejected ? '#991b1b' : '#a80000', mb: 0.5 }}>
        {isRejected ? 'Identity verification required' : 'Identity verification pending'}
      </Typography>
      <Typography sx={{ fontSize: 12, color: isRejected ? '#7f1d1d' : '#1e3a8a', lineHeight: 1.5 }}>
        {testerKycBlockedMessage(user)}{' '}
        <Box
          component={RouterLink}
          to="/app/settings?tab=kyc"
          sx={{ color: 'inherit', fontWeight: 700, textDecoration: 'underline' }}
        >
          Go to Settings → Identity
        </Box>
      </Typography>
    </Box>
  );
}
